module.exports = __webpack_public_path__ + "assets/img/web-bg.27b37caf.png";